"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var react_1 = __importStar(require("react"));
var Button_module_css_1 = __importDefault(require("./Button.module.css"));
var Button = (function (_super) {
    __extends(Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Button.prototype.onClick = function (event) {
        var onClick = this.props.onClick;
        event.preventDefault();
        event.stopPropagation();
        onClick();
    };
    Button.prototype.render = function () {
        var _a = this.props, text = _a.text, disabled = _a.disabled;
        return (react_1.default.createElement("button", { className: Button_module_css_1.default.button, onClick: this.onClick.bind(this), disabled: disabled }, text));
    };
    return Button;
}(react_1.Component));
exports.Button = Button;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQnV0dG9uLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvY29tcG9uZW50cy9EaXNjbG9zdXJlTW9kYWwvcGFydHMvQnV0dG9uL0J1dHRvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSw2Q0FBc0M7QUFDdEMsMEVBQXdDO0FBUXhDO0lBQTRCLDBCQUFvQjtJQUFoRDs7SUFnQkEsQ0FBQztJQWZXLHdCQUFPLEdBQWYsVUFBZ0IsS0FBSztRQUNWLElBQUEsT0FBTyxHQUFJLElBQUksQ0FBQyxLQUFLLFFBQWQsQ0FBYztRQUM1QixLQUFLLENBQUMsY0FBYyxFQUFFLENBQUE7UUFDdEIsS0FBSyxDQUFDLGVBQWUsRUFBRSxDQUFBO1FBQ3ZCLE9BQU8sRUFBRSxDQUFBO0lBQ2IsQ0FBQztJQUVNLHVCQUFNLEdBQWI7UUFDVSxJQUFBLEtBQW1CLElBQUksQ0FBQyxLQUFLLEVBQTVCLElBQUksVUFBQSxFQUFFLFFBQVEsY0FBYyxDQUFBO1FBQ25DLE9BQU8sQ0FDSCwwQ0FBUSxTQUFTLEVBQUUsMkJBQU0sQ0FBQyxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxFQUFFLFFBQVEsRUFBRSxRQUFRLElBQ2pGLElBQUksQ0FDQSxDQUNaLENBQUE7SUFDTCxDQUFDO0lBQ0wsYUFBQztBQUFELENBQUMsQUFoQkQsQ0FBNEIsaUJBQVMsR0FnQnBDO0FBaEJZLHdCQUFNIn0=